__turbopack_context__.v({
  "linkCard": "SubItem-module-scss-module__C0s_8a__linkCard",
  "linkDescription": "SubItem-module-scss-module__C0s_8a__linkDescription",
  "linkDetails": "SubItem-module-scss-module__C0s_8a__linkDetails",
  "linkTitle": "SubItem-module-scss-module__C0s_8a__linkTitle",
});
